import { FormBase } from 'core/components';
import moment from 'moment';
import validatorjs from 'validatorjs';

export default class ProductActivityForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'dateFormat',
			value => {
				return moment(value, 'MM/DD/YYYY', true).isValid();
			},
			'INVALIDDATEFORMAT'
		);
		return {
			fields: [
				{
					name: 'dateRangeStart',
					label: 'PRODUCTACTIVITYVIEW.LABEL.DATERANGESTART',
					rules: 'required|dateFormat',
				},
				{
					name: 'dateRangeEnd',
					label: 'PRODUCTACTIVITYVIEW.LABEL.DATERANGEEND',
					rules: 'dateFormat',
				},
				{
					name: 'warehouse',
					label: 'PRODUCTACTIVITYVIEW.LABEL.WAREHOUSE',
					rules: 'required',
				},
			],
		};
	}
	options() {
		return {
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: false,
			validateOnChangeAfterSubmit: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/ProductActivityForm.js